export default {
  courses: [],
  blog: [],
  news: [],
  products: [],
  lessons: []
};
